import { Box, Link, SxProps, Typography } from "@mui/material"
import { ClosedReason } from "../../types"

const ClosedPage = (props: { reason: ClosedReason }) => {
  const { reason } = props

  const title = {
    expired: "キャンペーンは終了しました。",
    couponUseageLimit: "クーポンの利用上限に達しました。",
    campaignMaintenance: "ページの表示に失敗しました。",
    maintenance: "ページの表示に失敗しました。",
    alreadyRequested: "ご応募済みです",
    notKateneMember: "カテエネ会員未登録です"
  }[reason]

  const textContent = {
    expired: `
        キャンペーンのご応募受付を終了いたしました。
        次回開催キャンペーンにご期待ください。
        `,
    couponUseageLimit: `
        残念ながらご好評につき、クーポンコードのご利用が上限数に達しました。
        次回開催キャンペーンにご期待ください。
        `,
    campaignMaintenance: <>
      お探しのページを開くことができませんでした。<br />
      <Link href="https://katene.chuden.jp/clubkatene/p/campaign/kurashi_prj/otoku/tsunagustore-cp/">キャンペーンページ</Link>へ戻り、再度お試しください。
    </>
    ,
    maintenance: `
    お探しのページを開くことができませんでした。
    URLをご確認の上、時間をおいて再度お試しください。
    `,
    alreadyRequested: `
    お客様のTCIDは、既に本キャンペーンへのご応募が完了しております。
    `,
    notKateneMember: <>
    お客様のTCIDは、カテエネにご登録いただいておりません。<br />
    本キャンペーンへのご応募には、カテエネ会員登録が必要です。<br />
    会員登録は<Link href="https://katene.chuden.jp/clubkatene/identry/idEntry.html">こちら</Link>
    </>
  }[reason]

  const attentions = {
    expired: "ブラウザの閉じるボタンで閉じてください。",
    couponUseageLimit: "ブラウザの閉じるボタンで閉じてください。",
    campaignMaintenance: `
    ※ブラウザ設定がシークレットモード（プライベートモード）になっていると、お手続きが正常に進まない可能性がございます。
    お使いの端末のセキュリティ設定をご確認の上、お手続きください。
    `,
    maintenance: "ブラウザの閉じるボタンで閉じてください。",
    alreadyRequested: "ブラウザの閉じるボタンで閉じてください。",
    notKateneMember: "ブラウザの閉じるボタンで閉じてください。"
  }[reason]

  const attentionStyle: SxProps = {
    expired: {},
    couponUseageLimit: {},
    campaignMaintenance: { fontSize: 10 },
    maintenance: {},
    alreadyRequested: {},
    notKateneMember: {}
  }[reason]

  return (
    <Box display="grid" justifyContent={"center"}>
      <Box display={"flex"} justifyContent={"center"}>
        <Typography variant="h6" color="gray" borderBottom={2} borderColor={"GrayText"}>{title}</Typography>
      </Box>
      <Box display="grid" justifyContent={"center"} paddingTop={3} color="gray">
        <Box display={"flex"} justifyContent={"center"}>
          <Typography sx={{ whiteSpace: 'pre-line' }} marginY={1} >{textContent}</Typography>
        </Box>
        <Box
          display={"flex"}
          paddingTop={3}
          justifyContent={"center"}>
          <Typography color="black" sx={{ whiteSpace: 'pre-line', ...attentionStyle }} marginY={5}>{attentions}</Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default ClosedPage